export const APM_DIRTY_RESPONSE_WITH_SLEEVE = {
	success: true,
	errors: [
		{
			code: 'MODEL_IS_OVERRIDDEN_AT_BLK',
			message: 'no',
			details: 'The model is imported in BLK'
		},
		{
			code: 'MODEL_IS_MODIFIED_AT_SOURCE',
			message: 'no',
			details: 'The model has been modified at source since its last import'
		},
		{
			code: 'MODEL_IS_A_FIRST_TIME_IMPORT',
			message: 'no',
			details: 'The model is imported for first time '
		}
	],
	status: 'OK',
	response: {
		id: 'b41daee1-fcf2-4ee0-a562-af2a064fd58e',
		description: 'APM Dirty With Sleeve',
		type: 'PORTFOLIO',
		subType: 'THIRD_PARTY_MODEL',
		children: [
			{
				identifier: 'IVV@464287200@US4642872000',
				identifierType: 'SECURITY_ID',
				weight: 30,
				allData: {
					date: 1589457125381,
					positionType: 'VALID',
					'@type': '_bws.user.WebUserData',
					description: 'iShares Core S&P 500 ETF',
					identifierType: 'SECURITY_ID',
					type: 'PORTFOLIO_POSITION',
					currentUserIsOwner: true,
					score: 1,
					dateCreated: 1589457125381,
					dateLastModified: 1589457125381,
					userEmail: 'rrandall@bfm.com',
					commonIdentifier: 'IVV@464287200@US4642872000',
					owner: {
						userPlatformId: '3225081',
						userEmail: 'rrandall@bfm.com',
						userId: 'rrandall@bfm.com'
					},
					identifier: 'IVV@464287200@US4642872000',
					ticker: 'IVV',
					trackingType: 'userData',
					userPlatformId: '3225081',
					childFlag: true,
					level: 1,
					updateUserId: 'rrandall@bfm.com',
					weight: 30,
					userId: 'rrandall@bfm.com',
					updateTimestamp: 1589457125612,
					parentId: 'b41daee1-fcf2-4ee0-a562-af2a064fd58e',
					parentType: 'PORTFOLIO',
					commonIdentifierType: 'SECURITY_ID',
					otherIdentifiers: [
						{
							identifier: 'IVV',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'TICKER'
						},
						{
							identifier: '464287200',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSIP'
						},
						{
							identifier: '0100000EOOP01112384HALRLCGAKIKCDGTJB7XPGCQL5ZORZMN2EQCMAA32MZVFA7F4BGKMQ====',
							customIdentifierType: 'ENVESTNET_HANDLE',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSTOM'
						}
					],
					originPlatform: {
						name: 'iShares Core S&P 500',
						type: 'SECURITY'
					},
					userTrackingId: '2555854',
					uniqueId: '1b4d5fd6-f256-44f1-b383-f31492befe7f'
				}
			},
			{
				identifier: 'AGG@464287226@US4642872265',
				identifierType: 'SECURITY_ID',
				weight: 30,
				allData: {
					date: 1589457125381,
					positionType: 'VALID',
					'@type': '_bws.user.WebUserData',
					description: 'iShares Core US Aggregate Bond ETF',
					identifierType: 'SECURITY_ID',
					type: 'PORTFOLIO_POSITION',
					currentUserIsOwner: true,
					score: 1,
					dateCreated: 1589457125381,
					dateLastModified: 1589457125381,
					userEmail: 'rrandall@bfm.com',
					commonIdentifier: 'AGG@464287226@US4642872265',
					owner: {
						userPlatformId: '3225081',
						userEmail: 'rrandall@bfm.com',
						userId: 'rrandall@bfm.com'
					},
					identifier: 'AGG@464287226@US4642872265',
					ticker: 'AGG',
					trackingType: 'userData',
					userPlatformId: '3225081',
					childFlag: true,
					level: 1,
					updateUserId: 'rrandall@bfm.com',
					weight: 30,
					userId: 'rrandall@bfm.com',
					updateTimestamp: 1589457125612,
					parentId: 'b41daee1-fcf2-4ee0-a562-af2a064fd58e',
					parentType: 'PORTFOLIO',
					commonIdentifierType: 'SECURITY_ID',
					otherIdentifiers: [
						{
							identifier: '0100000EOOP01114905HLOSJKO4FOOCQVJNCXQQKXFIZQUMDEYRADOFKSBH7USR3A6NVJATA====',
							customIdentifierType: 'ENVESTNET_HANDLE',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSTOM'
						},
						{
							identifier: 'AGG',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'TICKER'
						},
						{
							identifier: '464287226',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSIP'
						}
					],
					originPlatform: {
						name: 'iShares Core US Aggregate Bond',
						type: 'SECURITY'
					},
					userTrackingId: '2555854',
					uniqueId: 'b9b8bbc3-c3e7-4460-a870-815b0d789c46'
				}
			},
			{
				identifier: '1325e51b-fd84-4d2a-a3bd-94d86238e05d',
				identifierType: 'CUSTOM',
				weight: 40,
				portfolio: {
					id: '1325e51b-fd84-4d2a-a3bd-94d86238e05d',
					description: 'AS SLEEVE',
					type: 'PORTFOLIO',
					subType: 'THIRD_PARTY_MODEL',
					children: [
						{
							identifier: 'MBB@464288588@US4642885887',
							identifierType: 'SECURITY_ID',
							weight: 50,
							allData: {
								date: 1589302671666,
								positionType: 'VALID',
								'@type': '_bws.user.WebUserData',
								description: 'iShares MBS ETF',
								identifierType: 'SECURITY_ID',
								type: 'PORTFOLIO_POSITION',
								currentUserIsOwner: true,
								score: 1,
								dateCreated: 1589302671666,
								dateLastModified: 1589302671666,
								userEmail: 'rrandall@bfm.com',
								commonIdentifier: 'MBB@464288588@US4642885887',
								owner: {
									userPlatformId: '3225081',
									userEmail: 'rrandall@bfm.com',
									userId: 'rrandall@bfm.com'
								},
								identifier: 'MBB@464288588@US4642885887',
								ticker: 'MBB',
								trackingType: 'userData',
								userPlatformId: '3225081',
								childFlag: true,
								level: 1,
								updateUserId: 'rrandall@bfm.com',
								weight: 50,
								userId: 'rrandall@bfm.com',
								updateTimestamp: 1589302671749,
								parentId: '1325e51b-fd84-4d2a-a3bd-94d86238e05d',
								parentType: 'PORTFOLIO',
								commonIdentifierType: 'SECURITY_ID',
								otherIdentifiers: [
									{
										identifier: 'MBB',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									},
									{
										identifier: '464288588',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSIP'
									},
									{
										identifier: '0100000EOOP01188661HDEABL34IGFGJVALMZ2P2RP476VA3UTRUY2NAECKK33YSKHT6AD6Q====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									}
								],
								originPlatform: {
									name: 'iShares MBS',
									type: 'SECURITY'
								},
								userTrackingId: '2555854',
								uniqueId: '03961e71-df8f-4a80-9885-5842c5a71d37'
							}
						},
						{
							identifier: 'ENVESTNET_HANDLE@0100000EOOP0112054585HYLTDKILVBOXI4FTRAE5NDRHYLIYPBGVXNVLS4JGW6DGP2U6XTQ2Q====',
							identifierType: 'CUSTOM',
							weight: 40,
							allData: {
								date: 1589302671666,
								positionType: 'INVALID',
								'@type': '_bws.user.WebUserData',
								description: 'Blackrock Global Equity',
								identifierType: 'CUSTOM',
								type: 'PORTFOLIO_POSITION',
								currentUserIsOwner: true,
								score: 1,
								dateCreated: 1589302671666,
								dateLastModified: 1589302671666,
								userEmail: 'rrandall@bfm.com',
								owner: {
									userPlatformId: '3225081',
									userEmail: 'rrandall@bfm.com',
									userId: 'rrandall@bfm.com'
								},
								identifier: 'ENVESTNET_HANDLE@0100000EOOP0112054585HYLTDKILVBOXI4FTRAE5NDRHYLIYPBGVXNVLS4JGW6DGP2U6XTQ2Q====',
								ticker: 'TLO.BFD',
								trackingType: 'userData',
								userPlatformId: '3225081',
								childFlag: true,
								level: 1,
								updateUserId: 'rrandall@bfm.com',
								weight: 40,
								userId: 'rrandall@bfm.com',
								updateTimestamp: 1589302671749,
								parentId: '1325e51b-fd84-4d2a-a3bd-94d86238e05d',
								parentType: 'PORTFOLIO',
								otherIdentifiers: [
									{
										identifier: '0100000EOOP0112054585HYLTDKILVBOXI4FTRAE5NDRHYLIYPBGVXNVLS4JGW6DGP2U6XTQ2Q====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'TLO.BFD',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								],
								originPlatform: {
									name: 'Blackrock Global Equity',
									type: 'SECURITY'
								},
								userTrackingId: '2555854',
								uniqueId: '57859760-cdf7-40e2-b8d7-042ed78bc8cc'
							}
						},
						{
							identifier: 'IJR@464287804@US4642878049',
							identifierType: 'SECURITY_ID',
							weight: 10,
							allData: {
								date: 1589302671666,
								positionType: 'VALID',
								'@type': '_bws.user.WebUserData',
								description: 'iShares Core S&P Small-Cap ETF',
								identifierType: 'SECURITY_ID',
								type: 'PORTFOLIO_POSITION',
								currentUserIsOwner: true,
								score: 1,
								dateCreated: 1589302671666,
								dateLastModified: 1589302671666,
								userEmail: 'rrandall@bfm.com',
								commonIdentifier: 'IJR@464287804@US4642878049',
								owner: {
									userPlatformId: '3225081',
									userEmail: 'rrandall@bfm.com',
									userId: 'rrandall@bfm.com'
								},
								identifier: 'IJR@464287804@US4642878049',
								ticker: 'IJR',
								trackingType: 'userData',
								userPlatformId: '3225081',
								childFlag: true,
								level: 1,
								updateUserId: 'rrandall@bfm.com',
								weight: 10,
								userId: 'rrandall@bfm.com',
								updateTimestamp: 1589302671749,
								parentId: '1325e51b-fd84-4d2a-a3bd-94d86238e05d',
								parentType: 'PORTFOLIO',
								commonIdentifierType: 'SECURITY_ID',
								otherIdentifiers: [
									{
										identifier: '464287804',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSIP'
									},
									{
										identifier: '0100000EOOP0115899HVBI3IP22J7H4T2VCCUDLS5OFN3SZP3CJFU4IF4NPCWSZBO4KSN7Q====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: 'IJR',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								],
								originPlatform: {
									name: 'iShares Core S&P Small-Cap',
									type: 'SECURITY'
								},
								userTrackingId: '2555854',
								uniqueId: 'f25fd1c1-a672-429b-952d-f61b385c8036'
							}
						}
					],
					allData: {
						date: 1589302671666,
						'@type': 'com.bfm.webtools.api.domain.user.WebUserData',
						origin: 'partner',
						flags: {
							originContainsEditableModel: true,
							firstTimeImport: true,
							inputWithValues: false,
							isProcessed: false,
							originContainsUnmatchedSecurities: true,
							originContainsSleeves: false
						},
						description: 'AS SLEEVE',
						type: 'PORTFOLIO',
						currentUserIsOwner: true,
						score: 1,
						parentFlag: true,
						dateCreated: 1589302671666,
						dateLastModified: 1589302671666,
						userEmail: 'rrandall@bfm.com',
						perms: {
							DELETE: [
								'webUserDataPerm@AdvisorPort'
							],
							SHARE: [
								'webUserDataPerm@AdvisorPort'
							],
							VIEW: [
								'webUserDataPerm@AdvisorPort'
							]
						},
						owner: {
							userPlatformId: '3225081',
							userEmail: 'rrandall@bfm.com',
							userId: 'rrandall@bfm.com'
						},
						ssoIdp: 'envestnet',
						toolOrigin: 'partner',
						trackingType: 'userData',
						userPlatformId: '3225081',
						level: 0,
						updateUserId: 'rrandall@bfm.com',
						childCount: 3,
						userId: 'rrandall@bfm.com',
						updateTimestamp: 1589302671749,
						otherIdentifiers: [
							{
								identifier: '0100000EEEN015589354HURK5ULX22S77NLEE6B5ELMSQGFKP7TFIFU7BYLAYFEEPVBQZCXFQ====',
								customIdentifierType: 'ENVESTNET_HANDLE',
								'@type': '_bws.investments.IdentifierParam',
								identifierType: 'CUSTOM'
							}
						],
						subType: 'THIRD_PARTY_MODEL',
						originPlatform: {
							firm: 'BlackRock',
							dateImported: '1589302670645',
							programHandle: '0100000EEEN01613HTERU5ACK7K7LVH4SCFH27PYMT7DJGMUVG3XAIJDRRANTIEIPDECA====',
							portfolioType: 'ADVISOR_MODEL',
							externalModelDateLastModified: '1586323011800',
							riskHandle: '0100000EOOP03321HD7KPZBV2OZGSUA4SK3YGE54KF7AS47U6KSHNINRSVJDGSN6W6SLQ====',
							platform: 'ENVESTNET'
						},
						userTrackingId: '2555854',
						uniqueId: '1325e51b-fd84-4d2a-a3bd-94d86238e05d',
						applications: [
							'partner',
							'bfa'
						]
					}
				},
				allData: {
					date: 1589457125381,
					positionType: 'VALID',
					'@type': '_bws.user.WebUserData',
					description: 'AS SLEEVE',
					identifierType: 'CUSTOM',
					type: 'PORTFOLIO_POSITION',
					currentUserIsOwner: true,
					score: 1,
					dateCreated: 1589457125381,
					dateLastModified: 1589457125381,
					userEmail: 'rrandall@bfm.com',
					owner: {
						userPlatformId: '3225081',
						userEmail: 'rrandall@bfm.com',
						userId: 'rrandall@bfm.com'
					},
					identifier: '1325e51b-fd84-4d2a-a3bd-94d86238e05d',
					ticker: 'AS-22779',
					trackingType: 'userData',
					userPlatformId: '3225081',
					childFlag: true,
					level: 1,
					updateUserId: 'rrandall@bfm.com',
					weight: 40,
					userId: 'rrandall@bfm.com',
					updateTimestamp: 1589457125612,
					parentId: 'b41daee1-fcf2-4ee0-a562-af2a064fd58e',
					parentType: 'PORTFOLIO',
					otherIdentifiers: [
						{
							identifier: 'AS-22779',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'TICKER'
						},
						{
							identifier: '0100000EOOP0116030462HKDDZXCDR65ZIZA237IMB555YQDASIVHGURFEPFQHS4DUJ2P6LGDQ====',
							customIdentifierType: 'ENVESTNET_HANDLE',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSTOM'
						}
					],
					originPlatform: {
						name: 'AS SLEEVE',
						type: 'APM_SLEEVE'
					},
					userTrackingId: '2555854',
					uniqueId: 'f4fb9720-82c4-481d-b46d-82d633b88ade'
				}
			}
		],
		allData: {
			date: 1589457125381,
			'@type': 'com.bfm.webtools.api.domain.user.WebUserData',
			origin: 'partner',
			flags: {
				originContainsEditableModel: true,
				firstTimeImport: true,
				inputWithValues: false,
				isProcessed: false,
				originSleeveContainsUnmatchedSecurities: false,
				originContainsUnmatchedSecurities: false,
				originContainsSleeves: true
			},
			description: 'APM Dirty With Sleeve DP',
			type: 'PORTFOLIO',
			currentUserIsOwner: true,
			score: 1,
			parentFlag: true,
			dateCreated: 1589457125381,
			dateLastModified: 1589457125381,
			userEmail: 'rrandall@bfm.com',
			perms: {
				DELETE: [
					'webUserDataPerm@AdvisorPort'
				],
				SHARE: [
					'webUserDataPerm@AdvisorPort'
				],
				VIEW: [
					'webUserDataPerm@AdvisorPort'
				]
			},
			owner: {
				userPlatformId: '3225081',
				userEmail: 'rrandall@bfm.com',
				userId: 'rrandall@bfm.com'
			},
			ssoIdp: 'envestnet',
			toolOrigin: 'partner',
			trackingType: 'userData',
			userPlatformId: '3225081',
			level: 0,
			updateUserId: 'rrandall@bfm.com',
			childCount: 3,
			userId: 'rrandall@bfm.com',
			updateTimestamp: 1589457125613,
			otherIdentifiers: [
				{
					identifier: 'b41daee1-fcf2-4ee0-a562-af2a064fd58e',
					customIdentifierType: 'ENVESTNET_HANDLE',
					'@type': '_bws.investments.IdentifierParam',
					identifierType: 'CUSTOM'
				}
			],
			subType: 'THIRD_PARTY_MODEL',
			originPlatform: {
				firm: 'BlackRock',
				dateImported: '1589457125357',
				programHandle: '0100000EEEN01613HTERU5ACK7K7LVH4SCFH27PYMT7DJGMUVG3XAIJDRRANTIEIPDECA====',
				portfolioType: 'ADVISOR_MODEL',
				externalModelDateLastModified: '1589456813147',
				riskHandle: '0100000EOOP03319HHDGRBCT6R5HKSEOM7SVAPCF42QESC7I5246T3UHHCE5X5YGWBATQ====',
				platform: 'ENVESTNET'
			},
			userTrackingId: '2555854',
			uniqueId: 'b41daee1-fcf2-4ee0-a562-af2a064fd58e',
			applications: [
				'partner',
				'bfa'
			]
		}
	},
	responseTimes: {
		root: {
			nodes: [
				{
					data: {
						getModelDetails: 1.242
					},
					nodes: [
						{
							data: {
								accessToken: 0
							}
						},
						{
							data: {
								searchPortfolio: 0.411
							},
							nodes: [
								{
									data: {
										searchPortfolio: 0.405
									}
								}
							]
						},
						{
							data: {
								getPortfolioJson: 0.391
							},
							nodes: [
								{
									data: {
										getPortfolioJson: 0.208
									}
								}
							]
						}
					]
				}
			]
		}
	}
};

